import { FileService } from './../../services/file.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgProgress } from 'ngx-progressbar';
import { ReportingService } from '../../services/reporting.service';
import { InvoiceReportModel } from '../../models/invoice-report.model';
import { Sort } from '@angular/material/sort';
import { NgbCalendar, NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { TablefilterMultiplePipe } from '../../shared/pipes/tablefilter-multiple.pipe';
import { CommonService } from '../../services';
import { NgProgressService } from '../../services/ngProgress.service';
import { takeUntil } from 'rxjs/operators';

declare var $: any;


@Component({
  selector: 'app-reporting-dashboard',
  templateUrl: './reporting-dashboard.component.html',
  styleUrls: ['./reporting-dashboard.component.css']
})
export class ReportingDashboardComponent implements OnInit, OnDestroy {

  reportType = '';
  type = '';
  fromDate: NgbDate;
  toDate: NgbDate;
  strDateFrom = '';
  strDateTo = '';

  showPager = false;
  loadingFinished = false;
  loadContent = false;

  subscriptionReports: InvoiceReportModel[] = [];
  azureInvoiceReports: InvoiceReportModel[] = [];
  sortedData: InvoiceReportModel[] = [];

  hasEmptyFilterResult: boolean = false;

  filterResultArr: any;

  //search
  searchField: string;

  //export excel
   url: string;

   //unsubscribe
   ngUnsubscribe: Subject<void> = new Subject<void>();
  

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private calendar: NgbCalendar,
    private reportingService: ReportingService,
    private commonService: CommonService,
    private fileService: FileService,
    private ngProgress: NgProgressService
  ) { }

  dateFormat(date: any) {
    let month = {'jan': '01', 'feb': '02', 'mar': '03', 'apr': '04', 'may': '05', 'jun': '06', 
    'jul': '07', 'aug': '08', 'sep': '09', 'oct': '10', 'nov': '11', 'dec': '12'};
    let formatedDate = date.split('-');
    formatedDate[1] = month[formatedDate[1]];
    formatedDate = formatedDate.join('-');
    return formatedDate
  }
  
  sortData(sort: Sort) {
    let data = this.subscriptionReports.slice();
    if (this.type === 'AzureInvoiceReports')
      data = this.azureInvoiceReports.slice();
    if (!sort.active || sort.direction === '') {
      this.sortedData = data;
      return;
    }

    this.sortedData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'tenantName': return compare(a.tenantName.toLowerCase(), b.tenantName.toLowerCase(), isAsc);
        case 'tenantID': return compare(a.tenantID.toLowerCase(), b.tenantID.toLowerCase(), isAsc);
        case 'invoiceNo': return compare(a.invoiceNo.toLowerCase(), b.invoiceNo.toLowerCase(), isAsc);
        case 'invoiceDate': return compare(this.dateFormat(a.invoiceDate.toLowerCase()).split('-').reverse().join('-'), this.dateFormat(b.invoiceDate.toLowerCase()).split('-').reverse().join('-'), isAsc);
        case 'custReference': return compare(a.custReference.toLowerCase(), b.custReference.toLowerCase(), isAsc);
        case 'noOfSubscriptions': return compare(parseInt(a.noOfSubscriptions), parseInt(b.noOfSubscriptions), isAsc);
        case 'totalInvoiceAmount': return compare(parseFloat(a.totalInvoiceAmount), parseFloat(b.totalInvoiceAmount), isAsc);
        case 'subscriptionId': return compare(a.subscriptionId.toLowerCase(), b.subscriptionId.toLowerCase(), isAsc);
        case 'subscriptionName': return compare(a.subscriptionName.toLowerCase(), b.subscriptionName.toLowerCase(), isAsc);
        case 'usageEndDate': return compare(this.dateFormat(a.usageEndDate.toLowerCase()).split('-').reverse().join('-'), this.dateFormat(b.usageEndDate.toLowerCase()).split('-').reverse().join('-'), isAsc);
        case 'usageStartDate': return compare(this.dateFormat(a.usageStartDate.toLowerCase()).split('-').reverse().join('-'), this.dateFormat(b.usageStartDate.toLowerCase()).split('-').reverse().join('-'), isAsc);
        default: return 0;
      }
    });
  }


  ngOnInit() {

    this.activatedRoute.paramMap.subscribe(param => {
      this.ngProgress.start();

      // this.fromDate = this.calendar.getNext(this.calendar.getToday(), 'd', -14);
      let today = new Date();
      this.fromDate = new NgbDate(today.getFullYear(), today.getMonth()+1, 1)
      this.toDate = this.calendar.getToday();
      this.loadingFinished = false;
      this.loadContent = false;

      this.ngProgress.done();

      this.type = param.get('reportType');

      this.searchField = '';

       if (this.type === 'SubscriptionInvoiceReports') {
         this.reportType = 'Subscription Invoice Reports';
       } else if (this.type === 'AzureInvoiceReports') {
         this.reportType ='Azure Invoice Reports';
       } else {
         this.reportType = 'Reporting Dashboard';
       }

       //this.reportType = decodeURIComponent(type).toUpperCase();

       //initialize arrays 
       this.subscriptionReports = [];
       this.azureInvoiceReports = [];
       //this.showPager = false;


       if (this.type === 'SubscriptionInvoiceReports') {
        this.getInvoiceReportSummary();
       } else if (this.type === 'AzureInvoiceReports') {
         this.getAzureInvoiceReportSummary();
       }

    });

   
  }

  getInvoiceReportSummary() {
    this.convertDateFormat();
    this.reportingService.getInvoiceReportSummary(this.strDateFrom, this.strDateTo).pipe(takeUntil(this.ngUnsubscribe))
    .subscribe((value: InvoiceReportModel[]) => {
      this.subscriptionReports = value;
      this.sortedData = this.subscriptionReports.slice();

      // if (this.subscriptionReports.length > 20) 
      //     this.showPager = true;

      this.loadingFinished = true;
      this.loadContent = true;
   },
   (error: any) => {
    console.info(error),
    this.ngProgress.done();
   });
  }

  getAzureInvoiceReportSummary() {
    this.convertDateFormat();

    this.reportingService.getAzureInvoiceReportSummary(this.strDateFrom, this.strDateTo).pipe(takeUntil(this.ngUnsubscribe))
    .subscribe((value: InvoiceReportModel[]) => {
        this.azureInvoiceReports = value;
        this.sortedData = this.azureInvoiceReports.slice();
        
        // if (this.azureInvoiceReports.length > 20)
        //     this.showPager = true;

        this.sortedData.forEach(s => s.invoiceNo = s.invoiceNo.trim());

        this.loadingFinished = true;
        this.loadContent = true;

    },
    (error: any) => {
      console.info(error);
      this.ngProgress.done();
    });
  }

  exportCSPInvoice():void {
    this.ngProgress.start();
    this.convertDateFormat();

    this.reportingService.exportCSPInvoice(this.strDateFrom, this.strDateTo).pipe(takeUntil(this.ngUnsubscribe))
    .subscribe((data: any) => {
      const fileName = `CSPInvoiceReport_${this.strDateFrom}-${this.strDateTo}.xlsx`;

      this.fileService.saveAsExcelFile(data, fileName);
      this.ngProgress.done();
      this.commonService.implementToast('Invoice report downloaded successfully', 'Success');
    },
    (error: any) => {
      console.info(error),
      this.ngProgress.done();
    });
  }

  exportCSPUsageInvoice(invoiceNo:string, subscriptionId:string):void {
    this.ngProgress.start();
    this.convertDateFormat();

    if (invoiceNo) {
      //$(`#downloadBtn${invoiceNo}`).showValidator('Invoice report will be downloaded shortly', 'success', 'right');
      this.commonService.implementToast('Invoice report will be downloaded shortly', 'Info');

    } else {
      invoiceNo = '';
    }



    this.reportingService.exportCSPUsageInvoice(this.strDateFrom, this.strDateTo, invoiceNo, subscriptionId).pipe(takeUntil(this.ngUnsubscribe))
    .subscribe((data: any) => {
      let fileName = `CSPUsage_InvoiceReport_${this.strDateFrom}-${this.strDateTo}.xlsx`;

      if (invoiceNo != '') fileName = `CSPUsage_InvoiceReport_${invoiceNo}.xlsx`;

      this.fileService.saveAsExcelFile(data, fileName);

      this.ngProgress.done();
      this.commonService.implementToast('Invoice report downloaded successfully', 'Success');
    },
    (error: any) => {
      console.info(error),
      this.ngProgress.done();
    });
  }

  filterReports(): void {
    const isValid = this.validateDayRanges('btnFilter');
    
    if(!isValid) return;

    this.loadContent = false;

    if (this.type === 'SubscriptionInvoiceReports') {
        this.getInvoiceReportSummary();
      } else if (this.type === 'AzureInvoiceReports') {
        this.getAzureInvoiceReportSummary();
      }

  }

  downloadReports():void {
    const isValid = this.validateDayRanges('btnDownload');
    
    if(!isValid) return;

    this.ngProgress.start();
    //$('#btnDownload').showValidator('Invoice report will be downloaded shortly', 'success', 'right');
    this.commonService.implementToast('Invoice report will be downloaded shortly', 'Info');
    if (this.type === 'SubscriptionInvoiceReports') {
       this.exportCSPInvoice();
    } else if (this.type === 'AzureInvoiceReports') {
        this.exportCSPUsageInvoice('', '');
    }
  }

  convertDateFormat(): void {
    this.strDateFrom = this.fromDate.day + '/' + this.fromDate.month + '/' + this.fromDate.year;
    this.strDateTo = this.toDate.day + '/' + this.toDate.month + '/' + this.toDate.year;
    
  }

  validateDayRanges(btnName: string):boolean {
    const _MS_PER_DAY = 1000 * 60 * 60 * 24;
    const utcFrom = Date.UTC(this.fromDate.year, this.fromDate.month, this.fromDate.day);
    const utcTo = Date.UTC(this.toDate.year, this.toDate.month, this.toDate.day);

    const days = Math.floor((utcTo - utcFrom) / _MS_PER_DAY);

    if (days > 90) {
      $('#' + btnName).showValidator('Report date range can be maximum of 90 days', 'error', 'right');
      return false;
    } else if (days < 1) {
      $('#' + btnName).showValidator('Invalid date range selected', 'error', 'right');
      return false;
    }

    return true;
  }

  onLoading(currentLoadingStatus: boolean) {
   
    this.loadContent = !currentLoadingStatus;
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
 

  close() {
    //$('.page-contents').animate({ scrollLeft: -$('#levelOne').width() }, 400);
    this.router.navigateByUrl('/reporting');
  }

  onChange() {
    if (this.type === 'SubscriptionInvoiceReports') {
      this.filterResultArr = new TablefilterMultiplePipe().transform(this.sortedData, ['tenantName', 'invoiceNo', 'invoiceDate', 'custReference'], this.searchField);
    }
    else if (this.type === 'AzureInvoiceReports') {
      this.filterResultArr = new TablefilterMultiplePipe().transform(this.sortedData, ['invoiceNo', 'invoiceDate', 'cusReference', 'tenantName', 'subscriptionName', 'usageStartDate', 'usageEndDate'], this.searchField);
    }
    if (this.filterResultArr.length === 0 && this.searchField !=='') {
      this.hasEmptyFilterResult = true;

    } else {
      this.hasEmptyFilterResult = false;
    }
  }

  filterReset() {
    this.searchField = "";
    this.hasEmptyFilterResult = false;
  }

}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}

